import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    ViewChild, OnInit, OnDestroy,
} from '@angular/core';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatIconModule } from '@angular/material/icon';
import { TutorialServcie } from '../tutorial.service';
import { FormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { FuseScrollResetDirective } from '@fuse/directives/scroll-reset';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from 'app/modules/shared/services/markdown.service';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { VoiceInputButtonComponent } from 'app/ui/chat-kit/voice-input-button.component';
@Component({
    selector: 'app-tutorial',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        VoiceInputButtonComponent,
        NgIf,
        NgFor,
        NgClass,
        DatePipe,
        FormsModule,
        MatIconModule,
        TextFieldModule,
        FuseScrollbarDirective,
        FuseScrollResetDirective,
        TranslocoModule,
    ],
    templateUrl: './tutorial.component.html',
    styleUrl: './tutorial.component.scss',
})
export class TutorialComponent implements OnInit, OnDestroy {
    @ViewChild('messageInput') messageInput: ElementRef;
    @ViewChild('fuseScrollbar') fuseScrollbar: FuseScrollbarDirective;

    message: string = '';
    isLoading: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    lang: string = 'en';

    messages: {
        id: number;
        content: string;
        isMine: boolean;
        createdAt: Date;
        isMarkdown?: boolean;
    }[] = [
        {
            id: 1,
            content: 'How I Can Help you?',
            isMine: false,
            createdAt: new Date(),
            isMarkdown: false,
        },
    ];

    constructor(
        private _cdr: ChangeDetectorRef,
        private _tutorialService: TutorialServcie,
        private _markdownService: MarkdownService,
        private _translocoService: TranslocoService
    ) {}

    ngOnInit(): void {
        this._translocoService.langChanges$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {
                this.lang = res;
                this._cdr.markForCheck();
            });
    }

    sendMessage(): void {
        if (!this.message.trim()) return;

        const userMessage = {
            id: this.messages.length + 1,
            content: this.message.trim(),
            isMine: true,
            createdAt: new Date(),
            isMarkdown: false,
        };

        this.messages.push(userMessage);
        this.isLoading = true;
        this.message = '';
        this.scrollToBottom();
        this._tutorialService
            .ask({ prompt: userMessage.content, sessionID: '' })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res: any) => {
                this.displayResponseCharacterByCharacter(res.data.output);
            });
    }

    displayResponseCharacterByCharacter(answer: string) {
        this.isLoading = false;
        const responseMessage = {
            id: this.messages.length + 1,
            content: '',
            isMine: false,
            createdAt: new Date(),
            isMarkdown: true,
        };

        const words = answer.split(' ');

        this.messages.push(responseMessage);

        let index = 0;

        const typingInterval = setInterval(() => {
            if (index < words.length) {
                responseMessage.content +=
                    (index > 0 ? ' ' : '') + words[index];
                this._cdr.markForCheck();
                index++;
            } else {
                clearInterval(typingInterval);
                this.focusInput();
            }
        }, 20);
    }

    markDownContent(value: string): SafeHtml {
        return this._markdownService.processMarkedText(value);
    }

    scrollToBottom(): void {
        setTimeout(() => {
            if (this.fuseScrollbar) {
                this.fuseScrollbar.scrollToBottom(0, 300); // 300ms animation speed
            }
        }, 0); // Ensure DOM is updated first
    }

    focusInput(): void {
        const isMobileOrTablet = window.innerWidth <= 768;
        if (!isMobileOrTablet) {
            this.messageInput.nativeElement.focus();
        }
    }

    onKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.sendMessage();
        }
    }

    ngOnDestroy(): void {
        this.messages = [];
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    trackById(index: number, item: any): any {
        return item.id;
    }
}
